import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=c1615be4&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=c1615be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1615be4",
  null
  
)

export default component.exports